'use strict';

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _matrixJsSdk = require('matrix-js-sdk');

var _matrixJsSdk2 = _interopRequireDefault(_matrixJsSdk);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _index = require('../../../index');

var _index2 = _interopRequireDefault(_index);

var _languageHandler = require('../../../languageHandler');

var _SdkConfig = require('../../../SdkConfig');

var _SdkConfig2 = _interopRequireDefault(_SdkConfig);

var _ErrorUtils = require('../../../utils/ErrorUtils');

var _ServerTypeSelector = require('../../views/auth/ServerTypeSelector');

var ServerType = _interopRequireWildcard(_ServerTypeSelector);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MIN_PASSWORD_LENGTH = 6;

// Phases
// Show controls to configure server details
/*
Copyright 2015, 2016 OpenMarket Ltd
Copyright 2017 Vector Creations Ltd
Copyright 2018, 2019 New Vector Ltd

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

var PHASE_SERVER_DETAILS = 0;
// Show the appropriate registration flow(s) for the server
var PHASE_REGISTRATION = 1;

// Enable phases for registration
var PHASES_ENABLED = true;

module.exports = _react2.default.createClass({
    displayName: 'Registration',

    propTypes: {
        onLoggedIn: _propTypes2.default.func.isRequired,
        clientSecret: _propTypes2.default.string,
        sessionId: _propTypes2.default.string,
        makeRegistrationUrl: _propTypes2.default.func.isRequired,
        idSid: _propTypes2.default.string,
        // The default server name to use when the user hasn't specified
        // one. If set, `defaultHsUrl` and `defaultHsUrl` were derived for this
        // via `.well-known` discovery. The server name is used instead of the
        // HS URL when talking about "your account".
        defaultServerName: _propTypes2.default.string,
        // An error passed along from higher up explaining that something
        // went wrong when finding the defaultHsUrl.
        defaultServerDiscoveryError: _propTypes2.default.string,
        customHsUrl: _propTypes2.default.string,
        customIsUrl: _propTypes2.default.string,
        defaultHsUrl: _propTypes2.default.string,
        defaultIsUrl: _propTypes2.default.string,
        skipServerDetails: _propTypes2.default.bool,
        brand: _propTypes2.default.string,
        email: _propTypes2.default.string,
        // registration shouldn't know or care how login is done.
        onLoginClick: _propTypes2.default.func.isRequired,
        onServerConfigChange: _propTypes2.default.func.isRequired
    },

    getInitialState: function getInitialState() {
        var serverType = ServerType.getTypeFromHsUrl(this.props.customHsUrl);

        var customURLsAllowed = !_SdkConfig2.default.get()['disable_custom_urls'];
        var initialPhase = this.getDefaultPhaseForServerType(serverType);
        if (
        // if we have these two, skip to the good bit
        // (they could come in from the URL params in a
        // registration email link)
        this.props.clientSecret && this.props.sessionId ||
        // if custom URLs aren't allowed, skip to form
        !customURLsAllowed ||
        // if other logic says to, skip to form
        this.props.skipServerDetails) {
            // TODO: It would seem we've now added enough conditions here that the initial
            // phase will _always_ be the form. It's tempting to remove the complexity and
            // just do that, but we keep tweaking and changing auth, so let's wait until
            // things settle a bit.
            // Filed https://github.com/vector-im/riot-web/issues/8886 to track this.
            initialPhase = PHASE_REGISTRATION;
        }

        return {
            busy: false,
            errorText: null,
            // We remember the values entered by the user because
            // the registration form will be unmounted during the
            // course of registration, but if there's an error we
            // want to bring back the registration form with the
            // values the user entered still in it. We can keep
            // them in this component's state since this component
            // persist for the duration of the registration process.
            formVals: {
                email: this.props.email
            },
            // true if we're waiting for the user to complete
            // user-interactive auth
            // If we've been given a session ID, we're resuming
            // straight back into UI auth
            doingUIAuth: Boolean(this.props.sessionId),
            serverType: serverType,
            hsUrl: this.props.customHsUrl,
            isUrl: this.props.customIsUrl,
            // Phase of the overall registration dialog.
            phase: initialPhase,
            flows: null
        };
    },

    componentWillMount: function componentWillMount() {
        this._unmounted = false;
        this._replaceClient();
    },

    onServerConfigChange: function onServerConfigChange(config) {
        var _this = this;

        var newState = {};
        if (config.hsUrl !== undefined) {
            newState.hsUrl = config.hsUrl;
        }
        if (config.isUrl !== undefined) {
            newState.isUrl = config.isUrl;
        }
        this.props.onServerConfigChange(config);
        this.setState(newState, function () {
            _this._replaceClient();
        });
    },

    getDefaultPhaseForServerType: function getDefaultPhaseForServerType(type) {
        switch (type) {
            case ServerType.FREE:
                {
                    // Move directly to the registration phase since the server
                    // details are fixed.
                    return PHASE_REGISTRATION;
                }
            case ServerType.PREMIUM:
            case ServerType.ADVANCED:
                return PHASE_SERVER_DETAILS;
        }
    },
    onServerTypeChange: function onServerTypeChange(type) {
        this.setState({
            serverType: type
        });

        // When changing server types, set the HS / IS URLs to reasonable defaults for the
        // the new type.
        switch (type) {
            case ServerType.FREE:
                {
                    var _ServerType$TYPES$FRE = ServerType.TYPES.FREE,
                        hsUrl = _ServerType$TYPES$FRE.hsUrl,
                        isUrl = _ServerType$TYPES$FRE.isUrl;

                    this.onServerConfigChange({
                        hsUrl: hsUrl,
                        isUrl: isUrl
                    });
                    break;
                }
            case ServerType.PREMIUM:
            case ServerType.ADVANCED:
                this.onServerConfigChange({
                    hsUrl: this.props.defaultHsUrl,
                    isUrl: this.props.defaultIsUrl
                });
                break;
        }

        // Reset the phase to default phase for the server type.
        this.setState({
            phase: this.getDefaultPhaseForServerType(type)
        });
    },


    _replaceClient: function () {
        var _ref = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            this.setState({
                                errorText: null
                            });
                            this._matrixClient = _matrixJsSdk2.default.createClient({
                                baseUrl: this.state.hsUrl,
                                idBaseUrl: this.state.isUrl
                            });
                            _context.prev = 2;
                            _context.next = 5;
                            return (0, _bluebird.resolve)(this._makeRegisterRequest({}));

                        case 5:
                            // This should never succeed since we specified an empty
                            // auth object.
                            console.log("Expecting 401 from register request but got success!");
                            _context.next = 11;
                            break;

                        case 8:
                            _context.prev = 8;
                            _context.t0 = _context['catch'](2);

                            if (_context.t0.httpStatus === 401) {
                                this.setState({
                                    flows: _context.t0.data.flows
                                });
                            } else if (_context.t0.httpStatus === 403 && _context.t0.errcode === "M_UNKNOWN") {
                                this.setState({
                                    errorText: (0, _languageHandler._t)("Registration has been disabled on this homeserver.")
                                });
                            } else {
                                this.setState({
                                    errorText: (0, _languageHandler._t)("Unable to query for supported registration methods.")
                                });
                            }

                        case 11:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, this, [[2, 8]]);
        }));

        function _replaceClient() {
            return _ref.apply(this, arguments);
        }

        return _replaceClient;
    }(),

    onFormSubmit: function onFormSubmit(formVals) {
        // Don't allow the user to register if there's a discovery error
        // Without this, the user could end up registering on the wrong homeserver.
        if (this.props.defaultServerDiscoveryError) {
            this.setState({ errorText: this.props.defaultServerDiscoveryError });
            return;
        }
        this.setState({
            errorText: "",
            busy: true,
            formVals: formVals,
            doingUIAuth: true
        });
    },

    _onUIAuthFinished: function () {
        var _ref2 = (0, _bluebird.coroutine)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(success, response, extra) {
            var msg, errorTop, errorDetail, msisdnAvailable, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, flow, cli;

            return _regenerator2.default.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            if (success) {
                                _context2.next = 32;
                                break;
                            }

                            msg = response.message || response.toString();
                            // can we give a better error message?

                            if (!(response.errcode == 'M_RESOURCE_LIMIT_EXCEEDED')) {
                                _context2.next = 8;
                                break;
                            }

                            errorTop = (0, _ErrorUtils.messageForResourceLimitError)(response.data.limit_type, response.data.admin_contact, {
                                'monthly_active_user': (0, _languageHandler._td)("This homeserver has hit its Monthly Active User limit."),
                                '': (0, _languageHandler._td)("This homeserver has exceeded one of its resource limits.")
                            });
                            errorDetail = (0, _ErrorUtils.messageForResourceLimitError)(response.data.limit_type, response.data.admin_contact, {
                                '': (0, _languageHandler._td)("Please <a>contact your service administrator</a> to continue using this service.")
                            });

                            msg = _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    errorTop
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    errorDetail
                                )
                            );
                            _context2.next = 30;
                            break;

                        case 8:
                            if (!(response.required_stages && response.required_stages.indexOf('m.login.msisdn') > -1)) {
                                _context2.next = 30;
                                break;
                            }

                            msisdnAvailable = false;
                            _iteratorNormalCompletion = true;
                            _didIteratorError = false;
                            _iteratorError = undefined;
                            _context2.prev = 13;

                            for (_iterator = (0, _getIterator3.default)(response.available_flows); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                flow = _step.value;

                                msisdnAvailable |= flow.stages.indexOf('m.login.msisdn') > -1;
                            }
                            _context2.next = 21;
                            break;

                        case 17:
                            _context2.prev = 17;
                            _context2.t0 = _context2['catch'](13);
                            _didIteratorError = true;
                            _iteratorError = _context2.t0;

                        case 21:
                            _context2.prev = 21;
                            _context2.prev = 22;

                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }

                        case 24:
                            _context2.prev = 24;

                            if (!_didIteratorError) {
                                _context2.next = 27;
                                break;
                            }

                            throw _iteratorError;

                        case 27:
                            return _context2.finish(24);

                        case 28:
                            return _context2.finish(21);

                        case 29:
                            if (!msisdnAvailable) {
                                msg = (0, _languageHandler._t)('This server does not support authentication with a phone number.');
                            }

                        case 30:
                            this.setState({
                                busy: false,
                                doingUIAuth: false,
                                errorText: msg
                            });
                            return _context2.abrupt('return');

                        case 32:

                            this.setState({
                                // we're still busy until we get unmounted: don't show the registration form again
                                busy: true,
                                doingUIAuth: false
                            });

                            _context2.next = 35;
                            return (0, _bluebird.resolve)(this.props.onLoggedIn({
                                userId: response.user_id,
                                deviceId: response.device_id,
                                homeserverUrl: this._matrixClient.getHomeserverUrl(),
                                identityServerUrl: this._matrixClient.getIdentityServerUrl(),
                                accessToken: response.access_token
                            }));

                        case 35:
                            cli = _context2.sent;


                            this._setupPushers(cli);

                        case 37:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this, [[13, 17, 21, 29], [22,, 24, 28]]);
        }));

        function _onUIAuthFinished(_x, _x2, _x3) {
            return _ref2.apply(this, arguments);
        }

        return _onUIAuthFinished;
    }(),

    _setupPushers: function _setupPushers(matrixClient) {
        var _this2 = this;

        if (!this.props.brand) {
            return _bluebird2.default.resolve();
        }
        return matrixClient.getPushers().then(function (resp) {
            var pushers = resp.pushers;
            for (var i = 0; i < pushers.length; ++i) {
                if (pushers[i].kind === 'email') {
                    var emailPusher = pushers[i];
                    emailPusher.data = { brand: _this2.props.brand };
                    matrixClient.setPusher(emailPusher).done(function () {
                        console.log("Set email branding to " + _this2.props.brand);
                    }, function (error) {
                        console.error("Couldn't set email branding: " + error);
                    });
                }
            }
        }, function (error) {
            console.error("Couldn't get pushers: " + error);
        });
    },

    onFormValidationChange: function onFormValidationChange(fieldErrors) {
        // `fieldErrors` is an object mapping field IDs to error codes when there is an
        // error or `null` for no error, so the values array will be something like:
        // `[ null, "RegistrationForm.ERR_PASSWORD_MISSING", null]`
        // Find the first non-null error code and show that.
        var errCode = (0, _values2.default)(fieldErrors).find(function (value) {
            return !!value;
        });
        if (!errCode) {
            this.setState({
                errorText: null
            });
            return;
        }

        var errMsg = void 0;
        switch (errCode) {
            case "RegistrationForm.ERR_PASSWORD_MISSING":
                errMsg = (0, _languageHandler._t)('Missing password.');
                break;
            case "RegistrationForm.ERR_PASSWORD_MISMATCH":
                errMsg = (0, _languageHandler._t)('Passwords don\'t match.');
                break;
            case "RegistrationForm.ERR_PASSWORD_LENGTH":
                errMsg = (0, _languageHandler._t)('Password too short (min %(MIN_PASSWORD_LENGTH)s).', { MIN_PASSWORD_LENGTH: MIN_PASSWORD_LENGTH });
                break;
            case "RegistrationForm.ERR_EMAIL_INVALID":
                errMsg = (0, _languageHandler._t)('This doesn\'t look like a valid email address.');
                break;
            case "RegistrationForm.ERR_PHONE_NUMBER_INVALID":
                errMsg = (0, _languageHandler._t)('This doesn\'t look like a valid phone number.');
                break;
            case "RegistrationForm.ERR_MISSING_EMAIL":
                errMsg = (0, _languageHandler._t)('An email address is required to register on this homeserver.');
                break;
            case "RegistrationForm.ERR_MISSING_PHONE_NUMBER":
                errMsg = (0, _languageHandler._t)('A phone number is required to register on this homeserver.');
                break;
            case "RegistrationForm.ERR_USERNAME_INVALID":
                errMsg = (0, _languageHandler._t)("A username can only contain lower case letters, numbers and '=_-./'");
                break;
            case "RegistrationForm.ERR_USERNAME_BLANK":
                errMsg = (0, _languageHandler._t)('You need to enter a username.');
                break;
            default:
                console.error("Unknown error code: %s", errCode);
                errMsg = (0, _languageHandler._t)('An unknown error occurred.');
                break;
        }
        this.setState({
            errorText: errMsg
        });
    },

    onLoginClick: function onLoginClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.onLoginClick();
    },

    onGoToFormClicked: function onGoToFormClicked(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this._replaceClient();
        this.setState({
            busy: false,
            doingUIAuth: false,
            phase: PHASE_REGISTRATION
        });
    },
    onServerDetailsNextPhaseClick: function onServerDetailsNextPhaseClick(ev) {
        ev.stopPropagation();
        this.setState({
            phase: PHASE_REGISTRATION
        });
    },
    onEditServerDetailsClick: function onEditServerDetailsClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            phase: PHASE_SERVER_DETAILS
        });
    },


    _makeRegisterRequest: function _makeRegisterRequest(auth) {
        // Only send the bind params if we're sending username / pw params
        // (Since we need to send no params at all to use the ones saved in the
        // session).
        var bindThreepids = this.state.formVals.password ? {
            email: true,
            msisdn: true
        } : {};

        return this._matrixClient.register(this.state.formVals.username, this.state.formVals.password, undefined, // session id: included in the auth dict already
        auth, bindThreepids, null);
    },

    _getUIAuthInputs: function _getUIAuthInputs() {
        return {
            emailAddress: this.state.formVals.email,
            phoneCountry: this.state.formVals.phoneCountry,
            phoneNumber: this.state.formVals.phoneNumber
        };
    },

    renderServerComponent: function renderServerComponent() {
        var ServerTypeSelector = _index2.default.getComponent("auth.ServerTypeSelector");
        var ServerConfig = _index2.default.getComponent("auth.ServerConfig");
        var ModularServerConfig = _index2.default.getComponent("auth.ModularServerConfig");
        var AccessibleButton = _index2.default.getComponent("elements.AccessibleButton");

        if (_SdkConfig2.default.get()['disable_custom_urls']) {
            return null;
        }

        // If we're on a different phase, we only show the server type selector,
        // which is always shown if we allow custom URLs at all.
        if (PHASES_ENABLED && this.state.phase !== PHASE_SERVER_DETAILS) {
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(ServerTypeSelector, {
                    selected: this.state.serverType,
                    onChange: this.onServerTypeChange
                })
            );
        }

        var serverDetails = null;
        switch (this.state.serverType) {
            case ServerType.FREE:
                break;
            case ServerType.PREMIUM:
                serverDetails = _react2.default.createElement(ModularServerConfig, {
                    customHsUrl: this.state.discoveredHsUrl || this.props.customHsUrl,
                    defaultHsUrl: this.props.defaultHsUrl,
                    defaultIsUrl: this.props.defaultIsUrl,
                    onServerConfigChange: this.onServerConfigChange,
                    delayTimeMs: 250
                });
                break;
            case ServerType.ADVANCED:
                serverDetails = _react2.default.createElement(ServerConfig, {
                    customHsUrl: this.state.discoveredHsUrl || this.props.customHsUrl,
                    customIsUrl: this.state.discoveredIsUrl || this.props.customIsUrl,
                    defaultHsUrl: this.props.defaultHsUrl,
                    defaultIsUrl: this.props.defaultIsUrl,
                    onServerConfigChange: this.onServerConfigChange,
                    delayTimeMs: 250
                });
                break;
        }

        var nextButton = null;
        if (PHASES_ENABLED) {
            nextButton = _react2.default.createElement(
                AccessibleButton,
                { className: 'mx_Login_submit',
                    onClick: this.onServerDetailsNextPhaseClick
                },
                (0, _languageHandler._t)("Next")
            );
        }

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(ServerTypeSelector, {
                selected: this.state.serverType,
                onChange: this.onServerTypeChange
            }),
            serverDetails,
            nextButton
        );
    },
    renderRegisterComponent: function renderRegisterComponent() {
        if (PHASES_ENABLED && this.state.phase !== PHASE_REGISTRATION) {
            return null;
        }

        var InteractiveAuth = _index2.default.getComponent('structures.InteractiveAuth');
        var Spinner = _index2.default.getComponent('elements.Spinner');
        var RegistrationForm = _index2.default.getComponent('auth.RegistrationForm');

        if (this.state.doingUIAuth) {
            return _react2.default.createElement(InteractiveAuth, {
                matrixClient: this._matrixClient,
                makeRequest: this._makeRegisterRequest,
                onAuthFinished: this._onUIAuthFinished,
                inputs: this._getUIAuthInputs(),
                makeRegistrationUrl: this.props.makeRegistrationUrl,
                sessionId: this.props.sessionId,
                clientSecret: this.props.clientSecret,
                emailSid: this.props.idSid,
                poll: true
            });
        } else if (this.state.busy || !this.state.flows) {
            return _react2.default.createElement(
                'div',
                { className: 'mx_AuthBody_spinner' },
                _react2.default.createElement(Spinner, null)
            );
        } else {
            var onEditServerDetailsClick = null;
            // If custom URLs are allowed and we haven't selected the Free server type, wire
            // up the server details edit link.
            if (PHASES_ENABLED && !_SdkConfig2.default.get()['disable_custom_urls'] && this.state.serverType !== ServerType.FREE) {
                onEditServerDetailsClick = this.onEditServerDetailsClick;
            }

            // If the current HS URL is the default HS URL, then we can label it
            // with the default HS name (if it exists).
            var hsName = void 0;
            if (this.state.hsUrl === this.props.defaultHsUrl) {
                hsName = this.props.defaultServerName;
            }

            return _react2.default.createElement(RegistrationForm, {
                defaultUsername: this.state.formVals.username,
                defaultEmail: this.state.formVals.email,
                defaultPhoneCountry: this.state.formVals.phoneCountry,
                defaultPhoneNumber: this.state.formVals.phoneNumber,
                defaultPassword: this.state.formVals.password,
                minPasswordLength: MIN_PASSWORD_LENGTH,
                onValidationChange: this.onFormValidationChange,
                onRegisterClick: this.onFormSubmit,
                onEditServerDetailsClick: onEditServerDetailsClick,
                flows: this.state.flows,
                hsName: hsName,
                hsUrl: this.state.hsUrl
            });
        }
    },


    render: function render() {
        var AuthHeader = _index2.default.getComponent('auth.AuthHeader');
        var AuthBody = _index2.default.getComponent("auth.AuthBody");
        var AuthPage = _index2.default.getComponent('auth.AuthPage');

        var errorText = void 0;
        var err = this.state.errorText || this.props.defaultServerDiscoveryError;
        if (err) {
            errorText = _react2.default.createElement(
                'div',
                { className: 'mx_Login_error' },
                err
            );
        }

        var signIn = _react2.default.createElement(
            'a',
            { className: 'mx_AuthBody_changeFlow', onClick: this.onLoginClick, href: '#' },
            (0, _languageHandler._t)('Sign in instead')
        );

        // Only show the 'go back' button if you're not looking at the form
        var goBack = void 0;
        if (PHASES_ENABLED && this.state.phase !== PHASE_REGISTRATION || this.state.doingUIAuth) {
            goBack = _react2.default.createElement(
                'a',
                { className: 'mx_AuthBody_changeFlow', onClick: this.onGoToFormClicked, href: '#' },
                (0, _languageHandler._t)('Go back')
            );
        }

        return _react2.default.createElement(
            AuthPage,
            null,
            _react2.default.createElement(AuthHeader, null),
            _react2.default.createElement(
                AuthBody,
                null,
                _react2.default.createElement(
                    'h2',
                    null,
                    (0, _languageHandler._t)('Create your account')
                ),
                errorText,
                this.renderServerComponent(),
                this.renderRegisterComponent(),
                goBack,
                signIn
            )
        );
    }
});
//# sourceMappingURL=Registration.js.map